import { FC, ReactNode } from "react";
import styles from "./TableAction.module.scss";
import classNamesBind from "classnames/bind";

const cn = classNamesBind.bind(styles);

export const TableAction: FC<{ children?: ReactNode }> = function TableAction({
  children,
}) {
  return <span className={cn("action")} children={children} />;
};
